import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { PageContainer } from '../../../../components/page-container/page-container'
import type { RootState } from '../../../../redux/global-store'
import { paths } from '../../../../router/paths'
import { journeyReset } from '../../presentation/redux/actions/journey-actions'
import { concludedStyles, concludedTexts } from './journey.styles'
import { PrintReceiptModal } from '../../../../components/print-receipt-modal/print-receipt-modal'

export const JourneyConcluded = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { journey, conclude } = useSelector(
    (state: RootState) => state.journey.journey,
  )
  const [printOpen, setPrintOpen] = useState(false)

  useEffect(() => {
    // Se usuário recarrega a página sem ter vindo do fluxo, permitir seguir mesmo sem journey
  }, [])

  const handlePrint = () => setPrintOpen(true)

  const handleFinish = () => {
    // Limpa estado de journey para permitir criar nova jornada ao invés de redirecionar para home
    dispatch(journeyReset({ resetAll: true }))
    navigate(paths.journey.input)
  }

  return (
    <PageContainer type="authenticated" title={concludedTexts.title}>
      <div className={concludedStyles.container}>
        <div className={concludedStyles.card}>
          <p className="text-gray-700">{concludedTexts.description}</p>
          {journey && (
            <div className={concludedStyles.cardInfoWrapper}>
              <span>
                <strong>ID:</strong> {journey.journeyId}
              </span>
              <span>
                <strong>Ruta:</strong> {journey.routeCode}
              </span>
              <span>
                <strong>Monto Total:</strong>{' '}
                {new Intl.NumberFormat('es-GT', {
                  style: 'currency',
                  currency: 'GTQ',
                }).format(journey.totalAmount)}
              </span>
            </div>
          )}
          {!journey && !conclude.loading && (
            <div className={concludedStyles.cardInfoMuted}>
              {concludedTexts.noJourney}
            </div>
          )}
        </div>
        <PrintReceiptModal
          isOpen={printOpen}
          onClose={() => setPrintOpen(false)}
          type="journey"
          data={journey || null}
        />
        <div className={concludedStyles.buttonsWrapper}>
          <button className={concludedStyles.printButton} onClick={handlePrint}>
            <svg
              className={concludedStyles.icon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
              />
            </svg>
            {concludedTexts.print}
          </button>
          <button
            className={concludedStyles.finishButton}
            onClick={handleFinish}
          >
            <svg
              className={concludedStyles.icon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            {concludedTexts.finish}
          </button>
        </div>
      </div>
    </PageContainer>
  )
}

export default JourneyConcluded
